import styled, { keyframes } from "styled-components";

export const StyledStreakInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  justify-content: end;
`;

const StyledRotateAnimation = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
`;

export const StyledSyncIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  padding: 0 10px;

  & > * {
    cursor: pointer;
    animation: ${({ $processing }) =>
        $processing ? StyledRotateAnimation : "none"}
      1s infinite linear;
  }
`;